var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoGridGuides(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B8B8FF",
    d: "M0 10C0 4.477 4.477 0 10 0h40c5.523 0 10 4.477 10 10v40c0 5.523-4.477 10-10 10H10C4.477 60 0 55.523 0 50V10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#091540",
    fillRule: "evenodd",
    d: "M24.403 34.667H20.93a3.602 3.602 0 0 0-3.598 3.597v.805a3.602 3.602 0 0 0 3.598 3.598h3.472A3.6 3.6 0 0 0 28 39.069v-.805a3.6 3.6 0 0 0-3.597-3.597ZM39.07 17.333h-3.473A3.6 3.6 0 0 0 32 20.931v.805a3.6 3.6 0 0 0 3.597 3.597h3.472a3.6 3.6 0 0 0 3.598-3.597v-.805a3.601 3.601 0 0 0-3.598-3.598ZM39.07 29.333h-3.473A3.6 3.6 0 0 0 32 32.931v6.138a3.6 3.6 0 0 0 3.597 3.598h3.472a3.601 3.601 0 0 0 3.598-3.598v-6.138a3.601 3.601 0 0 0-3.598-3.598ZM24.403 17.333H20.93a3.602 3.602 0 0 0-3.598 3.598v6.138a3.602 3.602 0 0 0 3.598 3.598h3.472A3.6 3.6 0 0 0 28 27.069v-6.138a3.6 3.6 0 0 0-3.597-3.598Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGridGuides);
export default __webpack_public_path__ + "static/media/logo-grid-guides.efbdbe578bb9e1c4e068f52a4cc6a825.svg";
export { ForwardRef as ReactComponent };